(ns nl.mediquest.questionnaire-frontend.component.modal
  (:require
   [nl.mediquest.questionnaire-frontend.component.i18n :as i18n]
   [nl.mediquest.ui.core.modal :as modal]
   [nl.mediquest.ui.html :as html]))

(defn confirm-leave-modified-questionnaire-modal
  [{:keys [on-confirm]}]
  [:form.px-8.pt-6.mb-4
   [:p.text-primary.font-bold.text-l.mb-4.border-b
    [i18n/text :navigation-protection/confirm-title]]
   [:p [i18n/text :navigation-protection/confirm-message]]
   [:div.flex.items-center.justify-between.mt-6
    [html/button-secondary
     {:on-click #(modal/close!)}
     [i18n/text :navigation-protection/cancel-button]]
    [html/button-primary
     {:on-click #(do (modal/close!)
                     (on-confirm))}
     [i18n/text :navigation-protection/confirm-button]]]])
